module.exports = __webpack_public_path__ + "static/media/academia_05.ffaaf770.jpg";